import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeRight12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconEdgeRight12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.525 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6 2.5A.75.75 0 1 0 6 1a.75.75 0 0 0 0 1.5m5.17.5a.5.5 0 1 0-1 0v6a.5.5 0 0 0 1 0zM1.55 4.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M2.3 6A.75.75 0 1 1 .8 6a.75.75 0 0 1 1.5 0m-.75 3a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m5.2 1.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8.225 2.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m.75 7.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-5.2.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeRight12);
